export function tabChange() {
  if (document.querySelector('.js-tabTrigger')) {
    const tabTriggerAll = document.querySelectorAll('.js-tabTrigger');
    const tabContAll = document.querySelectorAll('.js-tabCont');
    const IS_SELECTED = 'is-selected';
    const IS_VIEW = 'is-view';

    /** tab change */
    tabTriggerAll.forEach((targetBox) => {
      targetBox.addEventListener('click', () => {
        // newsのメニューリストから全てのis-selectedを削除
        for (let i = 0; i < tabTriggerAll.length; i++) {
          tabTriggerAll[i].classList.remove(IS_SELECTED);
        }
        targetBox.classList.add(IS_SELECTED);

        // get data-tab="〇〇"
        const newsTabData = targetBox.dataset.tab;

        // 選択したメガメニューに対応したメニューにclass付与で表示
        newsTabJudge(newsTabData);
      });
    });

    // 選択したタブと一致したメガメニューの判別用の関数
    function newsTabJudge(targetBox) {
      const dataId = document.getElementById(targetBox);

      for (let i = 0; i < tabContAll.length; i++) {
        tabContAll[i].classList.remove(IS_VIEW);
      }

      dataId.classList.add(IS_VIEW);
    }
  }
}
